// RITA-1525 — Absatzweise Seitenaufteilung als reine Funktion.
//
// Eingabe sind die gemessenen Blockhöhen (im Browser gemessen, in Tests vorgegeben), Ausgabe die
// Block-Kennungen je Seite. Ein Block wandert als Ganzes auf die nächste Seite, wenn er nicht mehr
// passt (absatzweiser Umbruch, Entscheidung Julia 24.09.2026); die zeilengenaue Teilung eines
// Absatzes ist ausdrücklich nicht Teil der Probeversion. Ein manueller Seitenumbruch beendet die
// laufende Seite. Ein Block, der höher als der Textbereich ist, steht allein auf seiner Seite und
// wird als Überlauf gekennzeichnet.
export interface Blockmass {
  id: string;
  hoehePx: number;
  seitenumbruch?: boolean;
}

export interface Seiteninhalt {
  blockIds: string[];
  /** Ein Block war höher als der Textbereich und wird abgeschnitten dargestellt. */
  ueberlauf: boolean;
}

export function seitenAufteilen(masse: Blockmass[], inhaltHoehePx: number): Seiteninhalt[] {
  const seiten: Seiteninhalt[] = [];
  let aktuell: Seiteninhalt = { blockIds: [], ueberlauf: false };
  let belegt = 0;

  const seiteAbschliessen = () => {
    seiten.push(aktuell);
    aktuell = { blockIds: [], ueberlauf: false };
    belegt = 0;
  };

  masse.forEach((mass) => {
    if (mass.seitenumbruch) {
      // Der Umbruch gehört noch zur laufenden Seite (dort wird er markiert); eine leere Seite
      // erzeugt er nicht — ein Umbruch ganz am Anfang oder direkt nach einem Umbruch wirkt nicht.
      if (aktuell.blockIds.length > 0) {
        aktuell.blockIds.push(mass.id);
        seiteAbschliessen();
      }
      return;
    }
    const hoehe = Math.max(0, mass.hoehePx);
    if (hoehe > inhaltHoehePx) {
      if (aktuell.blockIds.length > 0) seiteAbschliessen();
      aktuell.blockIds.push(mass.id);
      aktuell.ueberlauf = true;
      seiteAbschliessen();
      return;
    }
    if (aktuell.blockIds.length > 0 && belegt + hoehe > inhaltHoehePx) {
      seiteAbschliessen();
    }
    aktuell.blockIds.push(mass.id);
    belegt += hoehe;
  });

  if (aktuell.blockIds.length > 0 || seiten.length === 0) seiten.push(aktuell);
  return seiten;
}

export default seitenAufteilen;
